<template>
<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.19971 1.75L5.69971 6.25L10.1997 1.75" stroke="#7985A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>
